import React from 'react';

const People = ({ students, teachers }) => {

    return (
        <div className="students-in-myclassroom-div">
            <div className="my-classroom-teachers">
                <h1>Teachers</h1>
                <hr className="dark-hr" />
                <div className="my-classroom-all-teachers">
                    {
                        (teachers && teachers.length) && (teachers.map((each, i) => (
                            <div key={i} className="my-classroom-each-teacher">
                                <p>{each.name}</p>
                                <hr />
                            </div>
                        )))
                    }
                </div>
            </div>
            <div className="my-classroom-students">
                <h1>Students</h1>
                <hr className="dark-hr" />
                <div className="my-classroom-all-students">
                    {
                        (students && students.length) ? (students.map((each, i) => (
                            <div key={i} className="my-classroom-each-student">
                                <p>{each.name}</p>
                                <hr />
                            </div>
                        )))
                            : ''
                    }
                </div>
            </div>
        </div>
    );
};

export default People;